ul.contextMenuContainer {
  background: white;
  border: solid 1px var(--color-easil-gray-x-light);
  box-shadow: 0 1px 2px 0 rgba(21, 21, 22, 0.12);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 10px 0;
  /* Use fixed positioning so the menu lives in viewport coordinates and
   * escapes the editor body's `overflow: hidden`. The handleReposition()
   * logic in ContextMenu.js measures and clamps in viewport coords too. */
  position: fixed;
  z-index: 10;
  /* Align the shared ContextMenuSubmenu (Select Layer) parent icon with
   * the 12px left offset used by regular <li> rows below. */
  --ctx-menu-icon-margin-start: 12px;
  --ctx-menu-icon-margin-end: 16px;
}

ul.contextMenuContainer > li {
  align-items: center;
  color: var(--color-easil-gray);
  display: flex;
  padding: 4px 16px 4px 12px;
  pointer-events: none;
  font-weight: 500;
}

ul.contextMenuContainer > li:not([disabled]) {
  color: var(--color-easil-black);
  cursor: pointer;
  pointer-events: unset;
}

ul.contextMenuContainer > li:not([disabled]):hover {
  background: whitesmoke;
}

ul.contextMenuContainer > li > svg {
  flex-shrink: 0;
  margin-right: 16px;
}

ul.contextMenuContainer > hr {
  border-color: #eee;
  border-style: solid;
  border-width: 1px 0 0 0;
  margin: 8px 0;
}

.beta {
  opacity: 0.4;
}
